import React from "react";
import { Popup, Icon } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import moment from "moment";

/**
 * Table component to display scope and context reasons.
 *
 * @param {object} props - Component props.
 * @param {array} props.data - Array of reasons.
 * @param {function} props.handleReasonChange - Function to handle reason change.
 * @param {function} props.addNewReson - Function to add new reason.
 */
export default function ScopeAndContextReasonsTable(props) {
  const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);
  const canEdit = props.permission.can_update;

  function onDateSelection(date, index) {
    props.handleReasonChange({
      target: {
        name: "date",
        value: moment(date).format("DD MMM YYYY"),
      },
    }, index);
  }

  function toggleCalendar() {
    setIsCalendarOpen((isOpen) => !isOpen);
  }

  return (
    <div className="scope-and-context-reason-container">
      <label>Update logs</label>
      <table className="participants">
        <thead>
          <tr>
            <th>Date</th>
            <th style={{ width: "400px" }}>Reason for update</th>
            <th>Key factors</th>
            <th>Author</th>
          </tr>
        </thead>
        <tbody>
          {props.data.length > 0 &&
            props.data.map((details, index) => {
              return (
                <tr key={index}>
                  <td className="date">
                    <div className="scope-and-context-reason-input-date">
                      <div className="text">
                        {details.date.length > 0 &&
                          moment(details.date).format("DD MMM YYYY")}
                      </div>
                      {canEdit && (
                        <div className="picker">
                          <Popup
                            open={isCalendarOpen}
                            trigger={
                              <Icon
                                name="calendar alternate"
                                link
                                circular
                                inverted
                                bordered
                              />
                            }
                            content={
                              <div>
                                <DatePicker
                                  onChange={(date) =>
                                    onDateSelection(date, index)
                                  }
                                  inline
                                  showYearDropdown
                                  showMonthDropdown
                                  useShortMonthInDropdown
                                  yearDropdownItemNumber={3}
                                />
                              </div>
                            }
                            onOpen={toggleCalendar}
                            onClose={toggleCalendar}
                            on="click"
                            position="bottom left"
                            basic
                            hoverable
                            flowing
                          />
                        </div>
                      )}
                    </div>
                  </td>
                  <td>
                    <textarea
                      className="scope-and-context-reason-for-update"
                      name="reason_for_update"
                      onChange={evt=>props.handleReasonChange(evt, index)}
                      value={details.reason_for_update}
                      style={{ opacity: 1 }}
                      disabled={!canEdit}
                    />
                  </td>
                  <td>
                    <textarea
                      className="scope-and-context-key-factors"
                      type="text"
                      name="key_factors"
                      onChange={evt=>props.handleReasonChange(evt, index)}
                      value={details.key_factors}
                      style={{ opacity: 1 }}
                      disabled={!canEdit}
                    />
                  </td>
                  <td>
                    <textarea
                      className="scope-and-context-author"
                      type="text"
                      name="author"
                      onChange={evt=>props.handleReasonChange(evt, index)}
                      value={details.author}
                      style={{ opacity: 1 }}
                      disabled={!canEdit}
                    />
                  </td>
                </tr>
              );
            })}
          {props.data.length == 0 && (
            <tr>
              <td colSpan={4}>
                <div style={{ padding: "8px 10px" }}>No records found</div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {canEdit && (
        <label
          className="new-details"
          onClick={props.addNewReson}
          style={{ cursor: "pointer", marginTop: 8 }}
        >
          <i className="user plus icon" />
          <u>&nbsp;Add Reason for update</u>
        </label>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/scope_and_context_reasons_table.js